import React, { ReactElement } from 'react';
import styled from '@emotion/styled';

interface CarouselPaginationProps {
  size: number;
  currentIndex: number;
}

export function CarouselPagination({
  size,
  currentIndex,
}: CarouselPaginationProps): ReactElement {
  return (
    <Container data-testid="carousel-pagination">
      { Array(size)
        .fill(0)
        .map((_, index) => (
          <Dot
            key={`${index + 1}`}
            current={currentIndex === index}
            aria-current={currentIndex === index}
          />
        )) }
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
`;

const Dot = styled.span<{ current: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 0 3px;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.2);
  transition: 0.15s background;
  ${({ current }) => current &&
    `
    width: 10px;
    height: 10px;
    background: rgba(0, 0, 0, .8);
  `}
`;
